import { EventSourceHandler } from '@sellsy/sse';

export default class ImportProgressEventSourceHandler extends EventSourceHandler {
    constructor() {
        super();
        this.type = 'corporation.import.progress';
    }

    handle(event) {
        window.sellsyapp.$store.dispatch('importsStore/updateImportList', event.data);
    }
}
